<!-- MFITTで発車時刻を過ぎて引換え操作をした場合 -->
<template>
  <ItemDialog ref="canNotExchangeAfterDeparture" image-type="alert">
    <template #content-area>
      <p class="text-center">
        発車時刻を過ぎたため購入（引き換え）はできません。<br />
        購入（引き換え）できるのは発車前までです。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCanNotExchangeAfterDeparture",
  setup() {
    const canNotExchangeAfterDeparture = ref(null);

    const openDialog = () => {
      canNotExchangeAfterDeparture.value.open();
    };

    const closeDialog = () => {
      canNotExchangeAfterDeparture.value.close();
    };

    return {
      canNotExchangeAfterDeparture,
      openDialog,
      closeDialog,
    };
  },
};
</script>
